"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractProfileData = void 0;
const extractProfileData = profile => {
  if (!profile?.firstName && !profile?.lastName) {
    return false;
  }
  return {
    firstName: profile.firstName ?? undefined,
    lastName: profile.lastName ?? undefined,
    shortenedFirstName: profile.firstName?.slice(0, 1),
    shortenedLastName: profile.lastName?.slice(0, 1)
  };
};
exports.extractProfileData = extractProfileData;
